import type { ContentResponse, ListRequestOptions } from 'types/index';

export default function () {
  const getContent = (url: string) => {
    return UseBaseApi<ContentResponse>('/api/content', {
      params: {
        url
      },
      keepalive: true
    });
  };

  const getPreview = (url: string) => {
    return UseBaseApi<ContentResponse>('/api/preview', {
      params: {
        url
      },
      keepalive: true
    });
  };

  async function getListContent<T>(options: ListRequestOptions) {
    return await UseBaseApi<T>('/api/content/list', {
      params: options,
      keepalive: true
    });
  }

  return {
    getContent,
    getPreview,
    getListContent
  };
}
